import { render, staticRenderFns } from "./channel-icon-app.vue?vue&type=template&id=5f452cc7"
import script from "./channel-icon-app.vue?vue&type=script&lang=js"
export * from "./channel-icon-app.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports